/*
    reducer for job create and edit
*/
import arrayMove from 'array-move';
import * as types from '../../constants';

export const initialJobEditState = {
   mode: '',
   organizationId: null,
   companyId: null,
   jobGroupId: null,
   privileges: {},
   title: '',
   description: '',
   location: null,
   city: null,
   state: null,
   zip: null,
   latitude: null,
   longitude: null,
   jobPageLoading: false,
   companyLoading: false,
   jobGroupLoading: false,
   jobGroupDetailLoading: false,
   trafficType: 'hosted',
   confidential: false,
   endDate: null, // date coming in from the drop down - 30 / 60 / 90 days
   compensationMode: 'SINGLE', // can be single or multiple fields
   locationType: 'full_address',
};

export const jobEditCreateReducer = (state = initialJobEditState, action) => {
   switch (action.type) {
      case types.JOB_CREATE_EDIT_PRIVILEGES:
         return {
            ...state,
            privileges: action.payload,
         };
      case types.JOB_CREATE_EDIT_MODE:
         return {
            ...state,
            mode: action.payload,
         };
      case types.JOB_CREATE_EDIT_CITY:
         return {
            ...state,
            city: action.payload,
         };
      case types.JOB_CREATE_EDIT_STATE:
         return {
            ...state,
            state: action.payload,
         };
      case types.JOB_CREATE_EDIT_TITLE:
         return {
            ...state,
            title: action.payload,
         };
      case types.JOB_CREATE_EDIT_DESCRIPTION:
         return {
            ...state,
            description: action.payload,
         };
      case types.JOB_CREATE_EDIT_INTERVIEW_QUESTIONS:
         return {
            ...state,
            jobQuestions: action.payload,
         };
      case types.JOB_REMOVE_INTERVIEW_QUESTION:
         return {
            ...state,
            jobQuestions: [...state.jobQuestions.filter((jobQuestion) => jobQuestion.questionId !== action.payload)],
         };
      case types.JOB_CREATE_EDIT_REORDER_JOB_QUESTIONS:
         return {
            ...state,
            jobQuestions: arrayMove(state.jobQuestions, action.payload.oldIndex, action.payload.newIndex),
         };
      case types.JOB_CREATE_EDIT_ZIP:
         return {
            ...state,
            zip: action.payload,
         };
      case types.JOB_CREATE_EDIT_SET_LATITUDE:
         return {
            ...state,
            latitude: action.payload,
         };
      case types.JOB_CREATE_EDIT_SET_LONGITUDE:
         return {
            ...state,
            longitude: action.payload,
         };
      case types.JOB_CREATE_EDIT_ORGANIZATION_ID:
         return {
            ...state,
            organizationId: action.payload,
         };
      case types.JOB_CREATE_EDIT_COMPANY_ID:
         return {
            ...state,
            companyId: action.payload,
         };
      case types.JOB_CREATE_EDIT_JOB_HASH_ID:
         return {
            ...state,
            hashId: action.payload,
         };
      case types.JOB_CREATE_EDIT_JOB_CONFIDENTIAL:
         return {
            ...state,
            confidential: action.payload,
         };
      case types.JOB_CREATE_EDIT_JOB_GROUP_ID:
         return {
            ...state,
            jobGroupId: action.payload,
         };
      case types.JOB_CREATE_EDIT_JOB_TRAFFIC_TYPE:
         return {
            ...state,
            trafficType: action.payload,
         };
      case types.JOB_CREATE_EDIT_LOADING:
         return {
            ...state,
            jobPageLoading: action.payload,
         };
      case types.JOB_CREATE_EDIT_COMPANY_LOADING:
         return {
            ...state,
            companyLoading: action.payload,
         };
      case types.JOB_CREATE_EDIT_JOBGROUP_LOADING:
         return {
            ...state,
            jobGroupLoading: action.payload,
         };
      case types.JOB_CREATE_EDIT_JOBGROUP_DETAIL_LOADING:
         return {
            ...state,
            jobGroupDetailLoading: action.payload,
         };
      case types.JOB_CREATE_COMPENSATION_MODE:
         return {
            ...state,
            compensationMode: action.payload,
         };
      case types.JOB_CREATE_SET_END_DATE:
         return {
            ...state,
            endDate: action.payload,
         };
      case types.JOB_CREATE_EDIT_SET_LOCATION_TYPE:
         return {
            ...state,
            locationType: action.payload,
         };
      case types.JOB_CREATE_EDIT_RESET:
         return {
            ...state,
            ...initialJobEditState,
         };

      default:
         return state;
   }
};
